Common = {}

function showError(elem) {
    $("#" + elem).show();
}

function hideError(elem) {
    $("#" + elem).hide();
}

// show containers
Common.showElems = function (elems) {
    elems.forEach(function (e) {
        if (e) {
            e.show();
        }
    })
}

// hide containers
Common.hideElems = function (elems) {
    elems.forEach(function (e) {
        if (e) {
            e.hide();
        }
    })
}

Common.enableElems = function (elems) {
    elems.forEach(function (e) {
        if (e) {
            e.prop('disabled', false);
        }
    })
}

Common.disableElems = function (elems) {
    elems.forEach(function (e) {
        if (e) {
            e.prop('disabled', true);
        }
    })
}

// remove the same attribute from many elements
Common.removeAttributeOnElements = function (attribute, elems) {
    elems.forEach(function (e) {
        if (e) {
            e.removeAttr(attribute);
        }
    })
}

// add the same attribute from many elements
/**
 * @deprecated Use {@link Common.addAttributeOnElements} with the array/object signature instead.
 *
 * Prefer the newer signature:
 *   Common.addAttributeOnElements([{ selector: ".some-class", attributes: { "data-id": "123" } }]);
 */
Common.addAttributeOnElements = function (attribute, elems) {
    elems.forEach(function (e) {
        if (e) {
            e.attr(attribute, true);
        }
    })
}

/**
 * elementsWithAttributes: Array of objects
 * Example:
 * [
 *   { selector: '.class1', attributes: { 'data-id': '123', 'title': 'Element 1' } },
 *   { selector: '#id1', attributes: { 'data-role': 'admin', 'aria-label': 'Admin Panel' } }
 * ]
 * */
Common.addAttributeOnElements = function (elementsWithAttributes) {
    if (!Array.isArray(elementsWithAttributes)) {
        console.error('Input must be an array of objects.');
        return;
    }

    elementsWithAttributes.forEach(item => {
        const { selector, attributes } = item;

        if (!selector || typeof attributes !== 'object') {
            console.warn('Invalid item format:', item);
            return;
        }

        const elements = document.querySelectorAll(selector);
        if (elements.length === 0) {
            console.warn(`No elements found for selector: ${selector}`);
            return;
        }

        elements.forEach(el => {
            for (const [attrName, attrValue] of Object.entries(attributes)) {
                el.setAttribute(attrName, attrValue);
            }
        });
    });
};


/**
 * @deprecated Use {@link Common.attachEventToElements} instead.
 *
 * This helper hides the native event parameter and uses a custom (todo/toSend) signature.
 * Prefer {@link Common.attachEventToElements} which forwards (event, ...args) and supports delegated binding.
 */
Common.addEvent = function (elems, type, todo, toSend) {
    elems.on(type, function () {
        todo(toSend ? toSend : $(this));
    })
}


/**
 * Attach a single event listener to multiple DOM elements.
 *
 * Supports both direct and delegated event binding.
 *
 * @param {jQuery|HTMLElement[]|HTMLElement|string} elements - Target elements (selector, DOM node, array, or jQuery)
 * @param {string} eventName - Event type: "click", "input", "submit", etc. (space-separated is supported)
 * @param {Function} handler - Function to execute. Receives (event, ...extraArgs) and preserves `this`.
 * @param {{selector?: string}=} [options] - Optional settings. If options.selector is provided, uses delegated binding.
 *
 * Examples:
 * Common.attachEventToElements("#btnSubmit", "click", submitForm);
 *
 * // Multiple elements (single call)
 * Common.attachEventToElements("#fieldA, #fieldB, .fieldC", "blur input", function (event) {
 *     console.log("Changed:", event.target);
 * });
 *
 * // Or via a jQuery collection
 * const $fields = $("#fieldA, #fieldB, .fieldC");
 * Common.attachEventToElements($fields, "blur input", function (event) {
 *     console.log("Changed:", event.target);
 * });
 *
 * // Delegated binding
 * Common.attachEventToElements(document, "click", function (event) {
 *     console.log("Clicked:", event.target);
 * }, { selector: ".child" });
 */
Common.attachEventToElements = function (elements, eventName, handler, options) {

    // Validate handler
    if (typeof handler !== "function") {
        console.error("Common.attachEventToElements: handler must be a function");
        return;
    }

    // Wrap elements into a jQuery object (supports selectors, arrays, DOM nodes, jQuery)
    const $elements = $(elements);

    if ($elements.length === 0) {
        // Don't hard-fail, but make debugging easier.
        console.warn("Common.attachEventToElements: no elements matched", elements);
        return;
    }

    // Support two common patterns:
    // 1) Direct binding:   attachEventToElements("#id", "click", handler)
    // 2) Delegated binding: attachEventToElements(document, "click", handler, { selector: ".child" })
    const selector = options && options.selector ? options.selector : undefined;

    // jQuery will pass (event, ...extraArgs) into the handler.
    // We forward that transparently and preserve `this`.
    const invoke = function () {
        return handler.apply(this, arguments);
    };

    if (selector) {
        $elements.on(eventName, selector, invoke);
        return;
    }

    $elements.on(eventName, invoke);
};


// common ajax call
// if cacheable null => cacheable: false
// if async null => async: false
// if timeout null => standard
Common.doAjax = function (type, url, successMethod, errorMethod, cacheable, async) {
    $.ajax({
        type: type,
        url: url,
        success: function (data) {
            successMethod(data);
        },
        error: function (err) {
            errorMethod(err);
        },
        cache: cacheable,
        async: async
    });
}

jQuery.noConflict()(function ($) {
    $('form').find('input[type="text"], input[type="password"], input:not([type="hidden"]), input[type="checkbox"]').keyup(function (event) {
        // If the user presses the "Enter" key on the keyboard
        if (event.key === "Enter") {
            // Cancel the default action, if needed
            event.preventDefault();
            // Trigger the button element with a click
            $('.keypress-btn').click();
        }
    });

    return jQuery;
});

Common.patterns = {
    "zipPattern": /^[^\$\?\+\[\]\\?!§%@&=_]+$/,
    "cityPattern": /^[^\$\?\+\[\]\\ยง!§%@&=_]+$/,
    "pecPattern": /^(([^<>\(\)\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    "customerNumberPattern": /^[0-9]+$/,
    "titlePattern": /^[^\$\?\+\[\]\\0-9?!§%@&=_]+$/,
    "contactStringPattern": /^[^\$\?\+\[\]\\0-9ยง!§%@&=_]+$/i, //first name last name including the ü and ' and í
    "fiscalNumberPattern": /^[^$\?\+\[\]\\?!§%@&=_]+$/,
    "naturalPattern": /^[^\$\?\+\[\]\\ยง!§%@&=_]+$/, //generic string check
    "taxPattern": /((?:\d{2,3}\/\d{3}\/\d{5})|(?:\d{3}\/\d{4}\/\d{4}))/,
    "phonePattern": /^[\+][0-9]{0,49}\d+$/,
    "requiredPhonePattern": /^\+[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,46}$/,
    "usernameRecoveryPattern": /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,30}$/,
    "cleanupRegex": /^[A-z]*[0-9]*$/,
    //"symbolRegex": /^([@,$,!,%,?,{,*,},&,+,\-,_,=,§,°,(,),\/])\g$/,
    "symbolRegex": /^([@,$,!,%,?,{,*,},&,+,\-,_,=,§,°,(,),\/])$/g,
    //this is not used "emailOld": /^(([^<>\(\)\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    "vatPatternat": /^(at)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternbe": /^(be)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternbg": /^(bg)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatterncy": /^(cy)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatterncz": /^(cz)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternde": /^(de)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatterndk": /^(dk)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternee": /^(ee)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatterngr": /^(el)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternes": /^(es)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternfi": /^(fi)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternfr": /^(fr)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatterngb": /^(gb)[0-9]{9}$/i,
    "vatPatternhr": /^(hr)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternhu": /^(hu)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternie": /^(ie)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternit": /^(it)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternlt": /^(lt)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternlu": /^(lu)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternlv": /^(lv)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternmt": /^(mt)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternnl": /^(nl)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternpl": /^(pl)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternpt": /^(pt)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternro": /^(ro)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternse": /^(se)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternsi": /^(si)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternsk": /^(sk)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternsm": /^(sm)[^\$\?\+\[\]\\ยง!§%@&=_]+$/i,
    "vatPatternxi": /^(gb)[0-9]{9}$/i
};

Common.validateField = function (toBeValidated, patternName) {
    var patternRegex = Common.patterns[patternName];
    if (patternRegex !== undefined && patternRegex !== null) {
        return patternRegex.test(toBeValidated);
    }
    return true;
};

// This validates the element given with its own pattern : true (validation succeded or patternName not present) , false (validation failed)
//if the patternNameAttribute is given, then it will be used in the validation, otherwise not
Common.patternValidation = function (element, patternNameAttribute) {
    if (!patternNameAttribute) {
        patternNameAttribute = element.getAttribute("patternName");
    }
    if (patternNameAttribute) {
        return Common.validateField(element.value, patternNameAttribute);
    }
    return true;
}
//Main and Secondary are dom elements ( $('#element-id'); )
Common.requireChangesBetweenTwoElements = function (main, secondary) {
    if (main.val()) {
        main.prop('required', true);
        if (secondary.val()) {
            secondary.prop('required', true);
        } else {
            secondary.removeAttr("required");
        }
    } else {
        secondary.prop('required', true);
        if (secondary.val()) {
            main.removeAttr("required");
        } else {
            main.prop('required', true);
        }
    }
};

Common.ajaxRequestFailure = function (err) {
    console.error(err);
    return false;
};

Common.hideServerErrorMessagesOnInputChange = function () {
    Common.hideElems([$("#server-error-msg"), $("#error-msg")]);
};

Common.saveTestCookie = function () {
    // create a test cookie
    document.cookie = "test-cookie=1";
    // check, if cookie is stored
    const cookiesEnabled = decodeURIComponent(document.cookie).indexOf( "test-cookie=" ) !== -1;
    // invalidate cookie
    document.cookie = "test-cookie=1; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    return cookiesEnabled;
}


/**
 * Validate Friendly Captcha widget state.
 * @param {HTMLElement|string} captchaElement - The captcha container DOM element or selector.
 * @returns {{ isValid: boolean, bindEvents: Function }}
 *
 * Usage:
 * const captcha = Common.validateCaptcha(".frc-captcha");
 * captcha.bindEvents();
 * if (!captcha.isValid) {...}
 */
Common.validateCaptcha = function (captchaElement) {

    const el = typeof captchaElement === "string"
        ? document.querySelector(captchaElement)
        : captchaElement;

    if (!el) {
        console.error("Common.validateCaptcha: Captcha element not found.");
        return { isValid: false, bindEvents: function(){} };
    }

    let captchaComplete = false;

    const bindEvents = function () {
        el.addEventListener("frc:widget.complete", () => {
            captchaComplete = true;
        });

        el.addEventListener("frc:widget.error", () => {
            captchaComplete = false;
        });

        el.addEventListener("frc:widget.expire", () => {
            captchaComplete = false;
        });
    };

    return {
        get isValid() {
            return captchaComplete;
        },
        bindEvents
    };
};
